const EieInvestmentStatus = Object.assign({
  CREATION: { title: 'Creation', status: 'creation', color: 'warn' },
  VALIDATION: { title: 'Validation', status: 'validation', color: 'warn' },
  RESERVING: { title: 'Reserving', status: 'reserving', color: 'warn' },
  PROCESSING: { title: 'Processing', status: 'processing', color: 'warn' },
  REJECTED: { title: 'Rejected', status: 'rejected', color: 'error' },
  CANCELLING: { title: 'Cancelling', status: 'cancelling', color: 'orange' },
  CANCELLED: { title: 'Cancelled', status: 'cancelled', color: 'error' },
  SUCCEEDED: { title: 'Succeeded', status: 'succeeded', color: 'success' },
});

Object.freeze(EieInvestmentStatus);

export default EieInvestmentStatus;



// WEBPACK FOOTER //
// ./src/enum/eie/EieInvestmentStatus.js